export default __webpack_public_path__ + "static/media/0xa0df47432d9d88bcc040e9ee66ddc7e17a882715.2c2b226e.svg";